module.exports = __webpack_public_path__ + "static/media/contact-desktop-1920.463ba9b7.jpg";